export default "__VITE_ASSET__4fcbd6cf__"